var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"sharer-rates-actions"},[_c('rates-action',{attrs:{"view":_vm.view,"show-range":_vm.showRange,"table-ref":_vm.tableRef,"allow-publish":true}}),_vm._v(" "),_c('default-tier-template-button')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }